import React from "react";
import { useNavigate } from "react-router-dom";
import BotonVolver from "../components/BotonVolver";

function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 20, textAlign: "center" }}>
      <BotonVolver fallback="/login" />
      <h1>🚫 Acceso denegado</h1>
      <p>No tienes permiso para ver esta página.</p>
      <p>Vuelve a la página de inicio.</p>
      <button
        onClick={() => navigate("/login", { replace: true })}
        style={{ marginTop: 16, padding: "14px 28px", border: "none", borderRadius: 12, background: "#2563eb", color: "#fff", fontSize: 17, fontWeight: 800, cursor: "pointer" }}
      >
        Ir a iniciar sesión
      </button>
    </div>
  );
}

export default Unauthorized;
